import { styled } from "@vitality-ds/system";
import BaseLabelStyles from "../Label/styles/BaseLabel.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseLegend = styled("legend", BaseLabelStyles);